<template>
  <v-container>
    <delete-training-dialog
      :dialog="destroyTrainingDialog"
      :itemToBeDeleted="itemToBeDeleted"
      @close="closeDestroyTrainingDialog($event)"
    />
    <v-row
      class="align-center justify-space-between"
      mt-5
    >
      <v-col
        cols="3"
      >
        <search-field
          label="Busque por nome de Treino"
          :loading="loadingSearch"
          @searchText="searchText = $event"
        />
      </v-col>
      <v-col
        cols="6"
        sm="2"
        class="mb-2"
      >
        <v-row
          class="align-center">
          <v-btn
            color="primary"
            dark
            @click="editItem({})"
          >
            <v-icon left size="20">mdi-dumbbell</v-icon>
            Adicionar Treinos
          </v-btn>
        </v-row>
      </v-col>

    </v-row>
    <v-row
      mt-5
    >
      <v-col xs12>
        <v-data-table
          :headers="headers"
          :items="exercises"
          disable-pagination
          disable-sort
          hide-default-footer
          no-data-text=""
          loading-text="Carregando... Aguarde"
          class="elevation-1"
        >
          <template v-slot:item.link="{ item }">
            <a :href="item.link"
                v-if="item.link"
                target="_blank">Visualizar</a>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
              v-if="isMyScope(item)"
              class="mr-2"
              fab
              x-small
            >
              <v-icon
                color="secondary"
                small
                @click="openTrainingDialog(item)"
              >
                mdi-pencil
              </v-icon>
            </v-btn>
            <v-btn
              v-if="isMyScope(item)"
              class="mr-2"
              fab
              x-small
            >
              <v-icon
                color="secondary"
                small
                @click="downloadCurrentTrainingPdf(item)"
              >
                mdi-download
              </v-icon>
            </v-btn>
            <v-btn
              v-if="isMyScope(item)"
              fab
              x-small
            >
              <v-icon
                color="secondary"
                small
                @click="deleteTrainingItem(item)"
              >
                mdi-delete
              </v-icon>
            </v-btn>

          </template>
          <template v-slot:footer>
            <div class="full-width">
              <infinite-loading
                @infinite="infiniteHandler">
                <template slot="no-more">Não há mais itens cadastrados</template>
                <template slot="no-results">Não há itens cadastrados</template>
              </infinite-loading>
            </div>

          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <create-or-update-training-library-dialog :dialog.sync="createOrUpdateTrainingDialog"
      :editedItem="currentTrainingAdmin" :editedIndex="currentTrainingAdminIndex"
      @update="update" :onlyName="true"/>
    <admin-training-detail @update="update($event)" />
    <create-or-update-exercise-admin-dialog @update="update($event)" />
  </v-container>

</template>

<script>
import DeleteTrainingDialog from '@/components/personal/configurations/exercises/DeleteTrainingDialog'
import { mapActions, mapGetters } from 'vuex'
import InfiniteLoading from 'vue-infinite-loading'
import SearchField from '@/components/base/SearchField'
import AdminLibraryService from '@/services/admin-library-service'
import DocumentService from '@/services/document-service.js'
import CreateOrUpdateTrainingLibraryDialog from '@/components/admin/configurations/trainings/CreateOrUpdateTrainingLibraryDialog'
import AdminTrainingDetail from '@/components/admin/configurations/trainings/AdminTrainingDetail'
import CreateOrUpdateExerciseAdminDialog from '@/components/admin/configurations/trainings/CreateOrUpdateExerciseAdminDialog'

export default {
  name: 'LibraryList',
  components: {
    DeleteTrainingDialog,
    CreateOrUpdateTrainingLibraryDialog,
    InfiniteLoading,
    SearchField,
    AdminTrainingDetail,
    CreateOrUpdateExerciseAdminDialog
  },
  mounted () {
    this.setLoader({ show: true })
    this.resetDialog()
  },
  data () {
    return {
      ...mapActions('base', ['setLoader', 'setSnackbar']),
      nextPage: 1,
      totalPages: 0,
      searchText: '',
      state: null,
      resetList: false,
      exercises: [],
      headers: [
        { text: 'Treino', sortable: false, value: 'name' },
        { text: '', value: 'actions', width: 210, align: 'center' }
      ],
      loadingSearch: true,
      editedItem: {},
      itemToBeDeleted: {},
      createOrUpdateTrainingDialog: false,
      destroyTrainingDialog: false,
      currentTrainingAdminIndex: -1,
      currentTrainingAdmin: {}
    }
  },
  computed: {
    ...mapGetters('auth', ['user']),
    ...mapGetters('admin', ['trainingToBeEvaluated'])
  },
  methods: {
    ...mapActions('base', ['fetchPdf']),
    ...mapActions('admin', ['resetDialog', 'setTrainingToBeEvaluated', 'setTrainingAdminDialog']),
    infiniteHandler ($state) {
      this.state = $state
      this.resetList = false
      if (this.nextPage === null) {
        $state.complete()
      } else {
        this.fetchTrainings()
      }
    },
    fetchTrainings () {
      AdminLibraryService.all({ q: this.searchText, page: this.nextPage })
        .then(({ data }) => {
          if (data.trainings.length > 0) {
            if (this.resetList) {
              this.exercises = []
            }
            this.exercises.push(...data.trainings)
            this.nextPage = data.meta.next_page
            this.totalPages = data.meta.total_count
            this.state.loaded()
          } else {
            this.exercises = []
            this.state.complete()
          }
        })
        .catch(({ response }) => {
          this.setSnackbar({
            color: 'error',
            show: true,
            message: response.data.errors.detail
          })
        })
        .finally(() => {
          this.loadingSearch = false
          this.setLoader({ show: false })
        })
    },
    resetInfinityLoadAndPagination () {
      this.exercises = []
      this.state.reset()
      this.nextPage = 1
      this.resetList = true
    },
    editItem (item) {
      this.editedItem = Object.assign({}, item)
      this.createOrUpdateTrainingDialog = true
    },
    deleteItem (item) {
      this.itemToBeDeleted = item
      this.destroyDialog = true
    },
    deleteTrainingItem (item) {
      this.itemToBeDeleted = item
      this.destroyTrainingDialog = true
    },
    closeDestroyTrainingDialog () {
      this.destroyTrainingDialog = false
      this.resetDialog()
      this.resetInfinityLoadAndPagination()
    },
    isMyScope (exercise) {
      return !exercise.personal_trainer_id
    },
    downloadCurrentTrainingPdf (item) {
      if (!item.exercises) {
        this.setSnackbar({
          color: 'error',
          show: true,
          message: `Adicione exercícios ao treino antes de baixar`
        })

        return
      }
      const payload = {
        trainingLibrary: item.id
      }
      const fileName = `Biblioteca - ${item.name}.pdf`

      this.setLoader({ show: true })
      this.fetchPdf({ service: DocumentService.getTrainingLibraryPdf, payload, fileName })
        .then(() => {
          console.log('PDF baixado com sucesso')
        })
        .catch(error => {
          const errorMessage = error.response && error.response.data && error.response.data.errors && error.response.data.errors.detail
            ? error.response.data.errors.detail
            : error.message || 'Erro desconhecido ao baixar PDF'
          this.setSnackbar({
            color: 'error',
            show: true,
            message: `Erro ao baixar PDF: ${errorMessage}`
          })
        })
        .finally(() => {
          this.setLoader({ show: false })
        })
    },
    update () {
      this.setLoader({ show: true })
      const payload = { ...this.trainingToBeEvaluated }
      AdminLibraryService.createOrUpdate(payload)
        .then(({ data }) => {
          this.resetList = true
          this.fetchTrainings()
        })
        .catch(({ response }) => {
          this.setSnackbar({
            color: 'error',
            show: true,
            message: response?.data?.errors?.detail || 'Ocorreu um erro ao salvar o treino.'
          })
        })
    },
    openTrainingDialog (training) {
      this.setTrainingToBeEvaluated(training)
      this.setTrainingAdminDialog(true)
    }
  },
  watch: {
    searchText () {
      const qLength = this.searchText.length
      if (qLength > 0 && qLength < 3) return
      this.loadingSearch = true
      this.resetInfinityLoadAndPagination()
    },
    createOrUpdateTrainingDialog () {
      this.resetDialog()
    }
  }
}
</script>
